export default function getResource(label, vars = []) {
    const resources = {
        // Landing CTAs (different label per channel per Figma).
        ctaMobile: 'Commencer',
        ctaDesktop: 'Lier les comptes Sephora et Starbucks',
        accountLinked: 'Compte lié',
        // Post-link shop actions (small UI). The "How Do I earn…" heading and step
        // cards are CMS-driven (BannerList sid Sephoraxstarbucks_HowtoEArn_bannerlist).
        shopOnline: 'Magasiner en ligne',
        shopMyStore: 'Magasiner en magasin',
        // Linked-state links.
        manageLinkedAccounts: 'Gérer vos comptes liés',
        seeAllPointsActivity: 'Voir toute l’activité des points',
        // Terms row. The terms URL is in constants (TERMS_URL).
        termsLinkLabel: 'Consulter les conditions générales du programme',
        termsBody: '',
        // Link Account modal (title falls back here if CMS omits it).
        linkModalTitle: 'Lier le compte',
        linkModalSubtitle: 'Avis et consentement',
        linkModalBody:
            'Pour participer à l’initiative de fidélité Starbucks Sephora, vous devez lier votre ' +
            'compte Starbucks™ à votre compte Sephora associé à un numéro de téléphone américain, et ' +
            'votre compte doit être en règle. Une fois vos comptes liés, vous pouvez accumuler des ' +
            'points Starbucks sur les transactions admissibles. En liant votre compte, vous consentez ' +
            'à ce que Sephora communique les détails de vos achats à Starbucks. Si vous ne souhaitez ' +
            'plus participer à cette offre, vous pouvez dissocier votre compte en tout temps dans ' +
            'l’application Sephora.',
        linkModalCheckbox: 'J’ai lu et j’accepte les conditions d’utilisation.',
        linkModalSubmit: 'Lier le compte',
        // Link-failure popup (Figma 3132-74072).
        linkErrorBody: 'Impossible de lier votre compte pour le moment. Veuillez réessayer.',
        linkErrorDismiss: 'OK'
    };

    return resources[label];
}
